__turbopack_context__.v({
  "accordionSlideOverwrite": "termSheetPreview-module-scss-module__TpcH6q__accordionSlideOverwrite",
  "disclosure": "termSheetPreview-module-scss-module__TpcH6q__disclosure",
  "fadeIn": "termSheetPreview-module-scss-module__TpcH6q__fadeIn",
  "fadeOut": "termSheetPreview-module-scss-module__TpcH6q__fadeOut",
  "header": "termSheetPreview-module-scss-module__TpcH6q__header",
  "headerBlankValue": "termSheetPreview-module-scss-module__TpcH6q__headerBlankValue",
  "headingField": "termSheetPreview-module-scss-module__TpcH6q__headingField",
  "headingFieldDate": "termSheetPreview-module-scss-module__TpcH6q__headingFieldDate",
  "headingFieldLabel": "termSheetPreview-module-scss-module__TpcH6q__headingFieldLabel",
  "headingFieldValue": "termSheetPreview-module-scss-module__TpcH6q__headingFieldValue",
  "headingFieldValueNoWrap": "termSheetPreview-module-scss-module__TpcH6q__headingFieldValueNoWrap",
  "headingRow": "termSheetPreview-module-scss-module__TpcH6q__headingRow",
  "left": "termSheetPreview-module-scss-module__TpcH6q__left",
  "logo": "termSheetPreview-module-scss-module__TpcH6q__logo",
  "logoImage": "termSheetPreview-module-scss-module__TpcH6q__logoImage",
  "right": "termSheetPreview-module-scss-module__TpcH6q__right",
  "scaleIn": "termSheetPreview-module-scss-module__TpcH6q__scaleIn",
  "scaleOut": "termSheetPreview-module-scss-module__TpcH6q__scaleOut",
  "termSheetPreview": "termSheetPreview-module-scss-module__TpcH6q__termSheetPreview",
  "title": "termSheetPreview-module-scss-module__TpcH6q__title",
  "zoomIn": "termSheetPreview-module-scss-module__TpcH6q__zoomIn",
  "zoomOut": "termSheetPreview-module-scss-module__TpcH6q__zoomOut",
});
